import { checkAccessToPath } from 'frontend/common/access-helpers'
import { ResourceSectionType } from 'frontend/common/layout/enum/resource-section-type'
import { computed } from 'vue'

export function useBusModuleSection(eou) {
  function hasAccessTo(path) {
    return checkAccessToPath(eou.value, path)
  }
  const section = computed(() => {
    const result = {
      name: 'Bus Module Resources',
      sectionType: ResourceSectionType.BusModule,
      items: [
        {
          title: 'Bus Routes',
          isDisabled: false,
          path: 'bus-module/routes',
          icon: 'mi-outlined mi-alt-route',
        },
        {
          title: 'Bus Subsystems',
          isDisabled: false,
          path: 'bus-module/subsystems',
          icon: 'mi-outlined mi-donut-small',
        },
        {
          title: 'Bus Timetables',
          isDisabled: false,
          path: 'bus-module/timetables',
          icon: 'mi-outlined mi-departure-board',
        },
        {
          title: 'Bus Shift Allocations',
          isDisabled: false,
          path: 'bus-module/allocations',
          icon: 'mi-outlined mi-account-tree flip-h',
        },
      ],
    }
    result.items = result.items.filter(el => hasAccessTo(el.path))
    if (result.items.length) {
      return result
    } else {
      return {}
    }
  })

  return section
}
